const HeroData = {
    heading: `Welcome to the world of React!`,
    subHeading: `This is a sample Hero section with some content.`,
    btnText: `Take me!`
};

export default HeroData;